// extracted by mini-css-extract-plugin
export default {"container":"PersonImage_container__usLKo","image":"PersonImage_image__OK5U5","favorite":"PersonImage_favorite__PezbN"};